import { render, staticRenderFns } from "./indexPedidos.vue?vue&type=template&id=68cbf96a&"
import script from "./indexPedidos.vue?vue&type=script&lang=ts&"
export * from "./indexPedidos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports